export default {
  nav: {
    categories: 'Categorías',
    topSites: 'Sitios destacados',
    compare: 'Comparar',
    submitSite: 'Enviar sitio',
    about: 'Acerca de',
    logIn: 'Iniciar sesión',
  },
  common: {
    back: 'Atrás',
    search: 'Buscar',
    loading: 'Cargando…',
    viewSimilarSites: 'Ver sitios similares',
  },
  hero: {
    badge: 'Motor de descubrimiento',
    titleA: 'Encuentra sitios similares a',
    titleB: 'tus favoritos.',
    titlePrefix: 'Encuentra sitios similares a',
    titleAccent: 'tus favoritos.',
    subtitle: 'Descubre competidores, alternativas y joyas ocultas en la web con puntuaciones de similitud precisas.',
    placeholder: 'Introduce un dominio (p. ej. stripe.com)',
    inputPlaceholder: 'Introduce un dominio (p. ej. stripe.com)',
    step1Label: 'Introduce un dominio',
    step1Desc: 'Escribe cualquier URL para empezar',
    step2Label: 'Obtén coincidencias',
    step2Desc: 'Nuestro motor encuentra sitios similares al instante',
    step3Label: 'Compara y decide',
    step3Desc: 'Analiza y compara alternativas',
    steps: {
      step1Label: 'Introduce un dominio',
      step1Desc: 'Escribe cualquier URL para empezar',
      step2Label: 'Obtén coincidencias',
      step2Desc: 'Nuestro motor encuentra sitios similares al instante',
      step3Label: 'Compara y decide',
      step3Desc: 'Analiza y compara alternativas',
    },
  },
  footer: {
    newsletterTitle: 'Mantente al día',
    newsletterDesc: 'Recibe informes semanales sobre sitios en tendencia y nuevas alternativas.',
    emailPlaceholder: 'tu@email.com',
    subscribe: 'Suscribirse',
    brandDesc: 'Descubre conexiones ocultas en la web. Encuentra sitios similares a tus favoritos con puntuación precisa.',
    explore: 'Explorar',
    popular: 'Popular',
    company: 'Empresa',
    compareSites: 'Comparar sitios',
    sitesLike: 'Sitios como',
    contact: 'Contacto',
    faq: 'FAQ',
    removeYourSite: 'Eliminar tu sitio',
    privacyPolicy: 'Política de privacidad',
    termsOfService: 'Términos del servicio',
    rights: 'Todos los derechos reservados.',
  },
  notFound: {
    title: '¡Ups! Página no encontrada',
    returnHome: 'Volver al inicio',
  },
  submitPage: {
    ctaTitle: '¿Conoces un sitio genial?',
    ctaDesc: 'Ayúdanos a hacer crecer la base enviando sitios que te gusten. Solo te lleva unos segundos.',
    ctaButton: 'Enviar sitio',
    pageTitle: 'Enviar un sitio',
    pageSubtitle: 'Ayúdanos a crecer enviando un sitio web para indexarlo.',
    successTitle: '¡Sitio enviado!',
    successReviewPrefix: 'Revisaremos',
    successReviewSuffix: 'y lo añadiremos a nuestro índice en breve.',
    backHome: 'Volver al inicio',
    domainLabel: 'Dominio *',
    domainPlaceholder: 'ej. example.com',
    descriptionLabel: 'Descripción',
    descriptionPlaceholder: 'Breve descripción del sitio',
    categoryLabel: 'Categoría',
    categorySelect: 'Elige una categoría',
    alternativeTo: 'Alternativa a (opcional)',
    alternativeNone: 'Ninguna — no es una alternativa',
    emailLabel: 'Tu correo',
    emailPlaceholder: 'tu@ejemplo.com',
    submitButton: 'Enviar sitio',
    submitFailed: 'Error al enviar',
    seoTitle: 'Enviar sitio | CiteMatch',
    seoDesc: 'Envía un sitio web para indexarlo en CiteMatch.',
  },
};

